<template>
  <div class="container">
    <div class="house-broken">
      <BrokenHouseIcon class="icon" />
    </div>

    <h1 class="page-title">Oops. Something’s Gone Wrong</h1>

    <p>Well&hellip; isn’t this awkward!</p>
  </div>
</template>

<script>
import BrokenHouseIcon from "@/assets/svg/icon-house-broken.svg";

export default {
  name: "NotFound",
  components: {
    BrokenHouseIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
}

.house-broken {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: #e1011b;
  width: 100px;
  height: 100px;
  margin: $spacing-large auto 0 auto;

  .icon {
    fill: white;
    width: 60px;
  }
}

p {
  font-size: $form-font-size;
  color: $grey-dark;
}
</style>
